import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import Route from '@ember/routing/route';
import CustomSessionService from 'dashboard/services/-session';
import CurrentUserService from 'dashboard/services/current-user';
import type Transition from '@ember/routing/transition';

export default class ClassesRoute extends Route {
  @service declare currentUser: CurrentUserService;
  @service declare router: RouterService;
  @service declare session: CustomSessionService;

  async beforeModel(transition: Transition): Promise<void> {
    this.session.requireAuthentication(transition, 'login');
    await this.currentUser.load();

    const { selectedPurchaserId } = this.currentUser;
    this.router.replaceWith('dashboard.account.classes', selectedPurchaserId);
  }
}
